import { Alert, Button, Result, Space, message } from "antd";
import React, { useState } from "react";
import { ResultStatusType } from "antd/es/result";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { clearToken, selectToken } from "features/auth/AuthSlice";
import { useLogoutMutation } from "features/auth/service/auth.service";
type Props = {
  error?: string[] | undefined;
  prefixError: string;
  // status?: ResultStatusType;
  statusCode?: number | string | undefined;
  handleExtra?: () => void;
  labelExtra?: string;
};
const ResultErrors = ({
  error = ["error_fetch"],
  // status = "info",
  prefixError,
  statusCode,
  handleExtra,
  labelExtra,
}: Props) => {
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();

  const dispatch = useAppDispatch();
  const [logout, logoutResult] = useLogoutMutation();
  //

  const [loading, setLoading] = useState<boolean>(false);

  ///////////////////////
  // function
  const handleClearToken = async () => {
    // dispatch(clearToken());
    setLoading(true);
    try {
      const res = await logout(1).unwrap();
      if (res) {
        messageApi.open({
          content: "Đăng xuất thành công",
          duration: 4,
          type: "success",
        });
      }
    } catch (error) {
      // messageApi.open({
      //   content: "Đăng xuất thất bại",
      //   duration: 4,
      //   type: "error",
      // });
    } finally {
      dispatch(clearToken());
    }
    setLoading(false);
  };

  const handleExtraError = () => {
    if (statusCode && statusCode === 401) {
      // dispatch(toggleShowLogin());
    } else {
      // handleExtra && handleExtra();
    }
  };
  let com = null;
  switch (statusCode) {
    case undefined:
      com = (
        <Button
          onClick={() => {
            handleExtra ? handleExtra() : window.location.reload();
          }}
        >
          {labelExtra ? labelExtra : "Tải lại"}
        </Button>
      );
      break;
    case 401:
      com = (
        <Space direction="horizontal">
          <Button
            onClick={() => {
              handleExtra && handleExtra();
              handleExtra &&
                messageApi.open({
                  key: "updatable",
                  content: "Đang tải lại",
                  type: "loading",
                });
              setTimeout(() => {
                messageApi.open({
                  key: "updatable",
                  type: "success",
                  content: "Đã tải lại !",
                  duration: 2,
                });
              }, 1000);
            }}
          >
            {labelExtra ? labelExtra : "Tải lại"}
          </Button>
          <Button
            loading={loading}
            onClick={() => {
              handleClearToken();
            }}
          >
            Đăng xuất
          </Button>
        </Space>
      );
      break;
    default:
      break;
  }
  ///////////////////

  return (
    <div>
      {contextHolder}
      <Alert
        message={error && t(`${prefixError}:errors.${error[0]}`)}
        banner
        closable
        type="info"
        action={com}
        // onClose={}
      />
      {/* <Result
        
        status={"warning"}
        title={error && t(`${prefixError}.${error[0]}`)}
        extra={
          <Space direction="horizontal">
            <Button
              onClick={() => handleExtraError()}
              type="primary"
              key="extra"
            >
              {statusCode && statusCode === 401
                ? "đăng nhập lại ?"
                : labelExtra
                ? labelExtra
                : "reload"}
            </Button>
            {token && (
              <Button
                onClick={() => handleClearToken()}
                type="primary"
                key="logout"
              >
                Đăng xuất
              </Button>
            )}
          </Space>
        }
      /> */}
    </div>
  );
};

export default ResultErrors;
